import "./department_page.css";
import { Carousel } from "react-responsive-carousel";
import { useParams, Link } from "react-router-dom";

import DataProvider from "hoc/data_provider";
import DepartmentNewsEvents from "./department_news_events";
import DepartmentCareerStories from "./department_career_stories";
import { marked } from "helpers/helpers";
import Layout from "components/layout/layout";
import axios from "axios";
import { useEffect, useRef, useState } from "react";

const DepartmentPage = () => {
    const { department } = useParams();
    const endPoint = `/web/departments/${department}`;

    return (
        <DataProvider
            key={department}
            endPoint={endPoint}
            component={Department}
        />
    );
};

export default DepartmentPage;

const placementBranches = [
    "Computer Engineering",
    "Information Technology",
    "Electronics & Communication Engineering",
    "Mechanical Engineering",
    "Civil Engineering",
    "Production Engineering",
    "Information and Communication Technology",
    "Electronics and Instrumentation Engineering",
];

const Department = ({ data }) => {
    const sidebar = useRef(null);
    const { department: departmentSlug } = useParams();
    const { department, labs } = data;

    const [hasNewsletter, setHasNewsletter] = useState(false);

    useEffect(() => {
        axios
            .get(`/web/department/newsletter/${departmentSlug}`)
            .then((res) => {
                const items = res?.data?.data?.items || [];
                setHasNewsletter(items.length > 0);
            })
            .catch(() => setHasNewsletter(false));
    }, [departmentSlug]);

    let keys = {
        "COMPUTER ENGINEERING": "c.e",
        "CIVIL ENGINEERING": "ci.e",
        "INFORMATION TECHNOLOGY": "i.t",
        "Electronics & Communication Engineering": "e&c.e",
        "MECHANICAL ENGINEERING": "m.e",
        "PRODUCTION ENGINEERING": "p.e",
        "APPLIED MECHANICS": "a.m",
        "Center of Excellence": "co.e",
        "INFORMATION AND COMMUNICATION TECHNOLOGY": "ict",
        "ELECTRONICS AND INSTRUMENTATION ENGINEERING": "eie",
        "Humanities and Science Department": "has",  
    }
    
    let manual_keys = {
        "COMPUTER ENGINEERING": "",
        "CIVIL ENGINEERING": "",
        "INFORMATION TECHNOLOGY": "assets/itlabs.pdf",
        "Electronics & Communication Engineering": "",
        "MECHANICAL ENGINEERING": "",
        "PRODUCTION ENGINEERING": "",
        "APPLIED MECHANICS": "",
        "Center of Excellence": "",
        "INFORMATION AND COMMUNICATION TECHNOLOGY": "",
        "ELECTRONICS AND INSTRUMENTATION ENGINEERING": "",
        "Humanities and Science Department": "",  
    }
    
    const { name, aboutdept, mission, message, vision, peo, pso } = department;

    const matchedPlacementBranch = placementBranches.find(
        (branch) => branch.toLowerCase() === name.toLowerCase()
    );

    const scrollTo = (e, id) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <Layout
            title={name}
            breadcrumb={[
                {
                    name: "Home",
                    path: "/",
                },
                {
                    name: name,
                },
            ]}
        >
            <div className="department-page">
                <div className="department-page-data">
                    <div className="department-info" id="info">
                        <div className="department-abboutdept">
                            <h3 className="department-info-title">About Department</h3>
                            <p
                                className="department-desc"
                                dangerouslySetInnerHTML={marked(aboutdept)}
                            ></p>
                        </div>
                        
                        <div className="department-vision">
                            <h3 className="department-info-title">Vision</h3>
                            <p
                                className="department-desc"
                                dangerouslySetInnerHTML={marked(vision)}
                            ></p>
                        </div>

                        <div className="department-mission">
                            <h3 className="department-info-title">Mission</h3>
                            <p
                                className="department-desc"
                                dangerouslySetInnerHTML={marked(mission)}
                            ></p>
                        </div>

                        <div className="department-peo">
                            <h3 className="department-info-title">PEOs</h3>
                            <p
                                className="department-desc"
                                dangerouslySetInnerHTML={marked(peo)}
                            ></p>
                        </div>

                        <div className="department-pso">
                            <h3 className="department-info-title">PSOs</h3>
                            <p
                                className="department-desc"
                                dangerouslySetInnerHTML={marked(pso)}
                            ></p>
                        </div>

                        <div className="department-message">
                            <h3 className="department-info-title">
                                HoD's Message
                            </h3>
                            <p
                                className="department-desc"
                                dangerouslySetInnerHTML={marked(message)}
                            ></p>
                        </div>
                    </div>
                </div>
                <div
                    className="department-sidebar-wrapper"
                    ref={sidebar}
                    id="sidebar-wrapper"
                >
                    <div className="department-sidebar">
                        <ul className="sidebar">
                            <li className="head-strip">
                                <p>{name}</p>
                            </li>
                            <li className="strip">
                                <a href="#info" onClick={(e) => scrollTo(e, "info")}>
                                    <i className="fa fa-arrow-right"></i>{" "}
                                    Information
                                </a>
                            </li>
                            <li className="strip">
                                <a href="#news-events" onClick={(e) => scrollTo(e, "news-events")}>
                                    <i className="fa fa-arrow-right"></i> News &amp; Events
                                </a>
                            </li>
                            <li className="strip">
                                <a href="#career-stories" onClick={(e) => scrollTo(e, "career-stories")}>
                                    <i className="fa fa-arrow-right"></i> Career &amp; Success Stories
                                </a>
                            </li>
                            <li className="strip">
                                <a href="#labs" onClick={(e) => scrollTo(e, "labs")}>
                                    <i className="fa fa-arrow-right"></i> Laboratory &amp; Facilities
                                </a>
                            </li>
                            <li className="strip">
                                <a href={`https://gecbhavnagar.ac.in/faculty/${keys[department.name]}`} target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-arrow-right"></i>{" "}
                                    Faculties
                                </a>
                            </li>
                            {matchedPlacementBranch && (
                                <li className="strip">
                                    <Link
                                        to={`/placement/placed-students?branch=${encodeURIComponent(
                                            matchedPlacementBranch
                                        )}`}
                                    >
                                        <i className="fa fa-arrow-right"></i> Record of Placed Students
                                    </Link>
                                </li>
                            )}
                            {hasNewsletter && (
                                <li className="strip">
                                    <Link to={`/department-newsletter/${departmentSlug}`}>
                                        <i className="fa fa-arrow-right"></i> Departmental Newsletter
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
                <div className="department-news-events">
                    <div id="news-events">
                        <DepartmentNewsEvents />
                    </div>
                    <div id="career-stories">
                        <DepartmentCareerStories />
                    </div>
                </div>
                <div className="department-labs" id="labs">
                    <h3 className="department-info-title">Laboratories and Facilities</h3>
                    <div className="department-labs-list">
                        {labs.map((lab) => {
                            return (
                                <LabCard
                                    key={lab._id}
                                    lab={lab}
                                    departmentName={department.name}
                                    manual_keys={manual_keys}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

const LabCard = ({ lab, departmentName, manual_keys }) => {
    const { title, description, images } = lab;

    // Get the manual link based on the department name.
    // Since the value already includes "assets/...", we just prepend a "/" to create a relative path.
    const manualLink = manual_keys[departmentName];

    return (
        <div className="lab-card">
            <Carousel
                className="lab-gallery"
                autoPlay={true}
                infiniteLoop={true}
                showThumbs={false}
                showIndicators={false}
            >
                {images.map((image, idx) => {
                    const img = `${axios.defaults.baseURL}/download/files/${image}`;
                    return (
                        <div className="lab_image" key={idx}>
                            <img src={img} alt="lab-imgs" />
                        </div>
                    );
                })}
            </Carousel>
            <div className="lab-info">
                <h5 className="lab-title">{title}</h5>
                <p className="lab-desc">
                    {description}
                    {/* Append "MORE" link if a manual link exists */}
                    {manualLink && manualLink.trim() !== "" && (
                        <>
                            {" "}
                            <a href={`/${manualLink}`} target="_blank" rel="noopener noreferrer">
                                MORE
                            </a>
                        </>
                    )}
                </p>
            </div>
        </div>
    );
};
